<template>
  <div>
    <Part1 v-if="step == 1" @next="step++"></Part1>
    <!-- <Part2 v-if="step == 2"></Part2> -->
  </div>
</template>

<script>
import Part1 from './BecTransferPart1.vue'
import Part2 from './BecTransferPart2.vue'
export default {
  components: {
    Part1,
    Part2
  },
  data() {
    return {
      step: 1
    }
  }
}
</script>
